import api from "./apiURL";
export async function getAllAmount() {
  try {
    const response = await api.get(`/api/v1/payment/totalcollected`);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}
